import React, { useEffect, useMemo, useState } from "react";
import { Navigate, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import api, { publicImg } from "../../core/api";
import { menuFor, allPaths } from "../../core/menu";
import { AppProvider, useApp } from "../../core/AppContext";
import { formatLongDate, todayIso, initials } from "../../core/format";
import Logo from "../../components/Logo";
import "./Dashboard.css";

function Shell() {
  const { user, meta } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [userMenu, setUserMenu] = useState(false);
  const [pending, setPending] = useState(0);
const [leave, setLeave] = useState(0);
useEffect(() => {
  api.get("/requests/leave/count").then((r) => setLeave(r.data.count || 0)).catch(() => {});
}, [user, location.pathname]);
  const menu = useMemo(() => menuFor(user?.role), [user]);

  useEffect(() => { setOpen(false); setUserMenu(false); }, [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => {
    setExpanded((prev) => {
      const next = { ...prev };
      menu.forEach((m) => { if (m.children?.some((c) => location.pathname.startsWith(c.path))) next[m.key] = true; });
      return next;
    });
  }, [menu, location.pathname]);

  useEffect(() => {
    if (user?.role !== "admin") return;
    api.get("/dashboard").then((r) => setPending(r.data.pendingRequests || 0)).catch(() => {});
  }, [user, location.pathname]);

  const title = useMemo(() => {
    for (const m of menu) {
      if (m.path && (m.end ? location.pathname === m.path : location.pathname.startsWith(m.path))) return m.title;
      for (const c of m.children || []) if (location.pathname.startsWith(c.path)) return c.title;
    }
    return "بندر تجاری و مسافری چارک";
  }, [menu, location.pathname]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login", { replace: true });
  };

  // مسیر خارج از دسترس نقش -> داشبورد
  if (!allPaths(user?.role).some((p) => (p === "/" ? location.pathname === "/" : location.pathname.startsWith(p)))) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="dash">
      <aside className={`side ${open ? "open" : ""}`}>
        <div className="side-brand">
          <Logo size={44} light />
          <div>
            <b>سامانه ایمنی بندر چارک</b>
            <small>HSE Charak Port</small>
          </div>
        </div>

        <nav className="side-nav">
          {menu.map((item) => {
            if (item.children) {
              const isOpen = !!expanded[item.key];
              return (
                <div key={item.key}>
                  <button type="button" className="side-link" onClick={() => setExpanded((e) => ({ ...e, [item.key]: !e[item.key] }))}>
                    <i className={item.icon} />
                    <span>{item.title}</span>
                    <i className={`fa-solid fa-chevron-down caret ${isOpen ? "rot" : ""}`} />
                  </button>
                  {isOpen && (
                    <div className="side-sub">
                      {item.children.map((c) => (
                        <NavLink key={c.key} to={c.path} className={({ isActive }) => `side-link ${isActive ? "active" : ""}`}>
                          <i className={c.icon} /><span>{c.title}</span>
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            return (
              <NavLink key={item.key} to={item.path} end={!!item.end} className={({ isActive }) => `side-link ${isActive ? "active" : ""}`}>
                <i className={item.icon} /><span>{item.title}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="side-user">
          {userMenu && (
            <div className="side-menu">
              <NavLink to="/settings"><i className="fa-solid fa-key" /> تغییر رمز عبور</NavLink>
              <button className="out" onClick={logout}><i className="fa-solid fa-arrow-right-from-bracket" /> خروج از سامانه</button>
            </div>
          )}
          <button className="side-user-btn" onClick={() => setUserMenu((v) => !v)}>
            {user?.photo ? <img className="avatar" src={publicImg("employees", user.photo)} alt="" /> : <span className="avatar">{initials(user?.fullName)}</span>}
            <span className="grow"><b>{user?.fullName}</b><small>{user?.positionName || meta?.roles?.[user?.role] || ""}</small></span>
            <i className="fa-solid fa-chevron-down" style={{ fontSize: 11 }} />
          </button>
        </div>
      </aside>
      <div className={`overlay ${open ? "show" : ""}`} onClick={() => setOpen(false)} />

      <div className="main">
        <header className="top no-print">
          <h1 className="top-title">
            <button className="icon-btn menu-btn" onClick={() => setOpen(true)} aria-label="منو"><i className="fa-solid fa-bars" /></button>
            {title}
          </h1>
          <div className="top-left">
          <button className="bell"
  title={leave ? `${leave} درخواست مرخصی در انتظار تأیید شما` : pending ? `${pending} درخواست در انتظار بررسی` : "اعلان‌ها"}
  onClick={() => (leave ? navigate("/leave-approvals") : pending && navigate("/requests/personal"))}>
  <i className="fa-regular fa-bell" />
  {(leave || pending) > 0 && <span className="cnt">{leave || pending}</span>}
</button>
            <span className="date"><i className="fa-regular fa-calendar" />{formatLongDate(todayIso())}</span>
          </div>
        </header>
        <main className="content"><Outlet /></main>
      </div>
    </div>
  );
}

export default function Layout() {
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}
